import { render, staticRenderFns } from "./xcontrato.vue?vue&type=template&id=f506cefc&scoped=true"
import script from "./xcontrato.vue?vue&type=script&lang=js"
export * from "./xcontrato.vue?vue&type=script&lang=js"
import style0 from "./xcontrato.vue?vue&type=style&index=0&id=f506cefc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f506cefc",
  null
  
)

export default component.exports